import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CALENDLY_URL } from "@/data/nav";

export const SEASE = [0.22, 1, 0.36, 1];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { duration: 1.5 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Reveal = ({ children, delay = 0, y = 30, className = "", as = "div", ...rest }) => {
  const Tag = motion[as];
  return (
    <Tag className={className} initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9, ease: SEASE, delay }} {...rest}>
      {children}
    </Tag>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-mono text-[11px] uppercase tracking-[0.3em] text-brand ${className}`}>{children}</p>
);

export const H2 = ({ children, className = "" }) => (
  <h2 className={`font-display text-4xl font-bold leading-[0.98] tracking-tight sm:text-6xl lg:text-7xl ${className}`}>{children}</h2>
);

const PILL = {
  pink: "bg-brand text-white hover:bg-white hover:text-sink",
  outline: "border border-white/25 text-white hover:border-brand hover:text-brand",
};

export const Pill = ({ label, variant = "pink", onClick, testid, className = "" }) => {
  const cls = `group inline-flex h-12 items-center justify-center gap-2 rounded-full px-7 font-mono text-[11px] font-medium uppercase tracking-[0.2em] transition-[background-color,color,border-color,transform] duration-300 hover:-translate-y-0.5 sm:h-14 sm:px-8 ${PILL[variant]} ${className}`;
  const icon = <ArrowUpRight className="h-4 w-4 transition-transform duration-500 group-hover:rotate-45" />;
  if (onClick) return <button type="button" onClick={onClick} data-testid={testid} data-cursor="link" className={cls}>{label}{icon}</button>;
  return <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" data-testid={testid} data-cursor="link" className={cls}>{label}{icon}</a>;
};

export const Loop = ({ src, className = "", ...rest }) => (
  <video src={src} autoPlay muted loop playsInline preload="metadata" className={`h-full w-full object-cover ${className}`} {...rest} />
);
